<script setup lang="ts">
import TheBackdrop from '@/components/TheBackdrop.vue'
import TheNav from '@/components/TheNav.vue'
import TheFooter from '@/components/TheFooter.vue'
import TweaksPanel from '@/components/TweaksPanel.vue'
import HeroSection from '@/components/HeroSection.vue'
import StatsRow from '@/components/sections/StatsRow.vue'
import ExperienceTimeline from '@/components/sections/ExperienceTimeline.vue'
import SkillsGrid from '@/components/sections/SkillsGrid.vue'
import ProjectsGrid from '@/components/sections/ProjectsGrid.vue'
import EduLangPanels from '@/components/sections/EduLangPanels.vue'
import ContactCard from '@/components/sections/ContactCard.vue'
import { useReveal } from '@/composables/useReveal'
import { useScrollChrome } from '@/composables/useScrollChrome'

// Инициализируем глобальные composables — тема и tweaks применяются на импорте.
import '@/composables/useTheme'
import '@/composables/useTweaks'
import '@/composables/useLocale'

const { progressWidth, navScrolled } = useScrollChrome()
useReveal()
</script>

<template>
  <div class="progress" :style="{ width: progressWidth }"></div>
  <TheBackdrop />
  <TheNav :scrolled="navScrolled" />
  <main>
    <HeroSection />
    <StatsRow />
    <ExperienceTimeline />
    <SkillsGrid />
    <ProjectsGrid />
    <EduLangPanels />
    <ContactCard />
  </main>
  <TheFooter />
  <TweaksPanel />
</template>
